import { __decorate, __metadata } from "tslib";
import _ from 'lodash';
import { injectService, provide } from '@/inversify.config';
import { i18nSymbol } from '@/i18n';
export const WORKSPACE = 'workspace';
export const PATENT = 'patent';
// self 类型为 工作空间 & 专利
const SELF = 'self';
// shared 类型为 工作空间
const SHARE = 'shared';
const ALL = 'all';
const PUBLIC = 'public';
export const WORKSPACE_LIST_DEFAULT_TYPE_CACHE_KEY = 'workspace-list-default-type';
const { find, remove, isEqual, cloneDeep, pickBy } = _;
export const WorkspaceLabelServiceSymbol = Symbol.for('WorkspaceLabelService');
let WorkspaceLabelService = class WorkspaceLabelService {
    constructor() {
        this.i18n = injectService(i18nSymbol);
        this.labelId = '';
        this.labelName = '';
        this.selectedlabelIds = [];
        this.originLabelOptions = [];
        this.labelOptions = [];
        this.outLabelOption = [];
        this.searchName = '';
        this.searchTypeInPane = WORKSPACE;
        // 专利page
        this.page = 1;
        // space page
        this.pageNum = 1;
        this.spaceType = ALL;
        this.allSpaceList = [];
        // sort
        this.cacheKey = 'workspace-view-order';
        this.sortKeyMap = {
            CREATE_TIME_ASC: 'CREATE_TIME_ASC',
            CREATE_TIME_DESC: 'CREATE_TIME_DESC',
            UPDATE_TIME_DESC: 'UPDATE_TIME_DESC',
            ACCESS_TIME_DESC: 'ACCESS_TIME_DESC',
            NAME: 'NAME',
        };
        this.defaultSortKey = 'ACCESS_TIME_DESC';
    }
    getAllSpaceList(res) {
        if (!this.searchName && !this.labelName) {
            this.allSpaceList = res;
        }
    }
    getDefaultWorkspaceListType() {
        const cache = localStorage.getItem(WORKSPACE_LIST_DEFAULT_TYPE_CACHE_KEY);
        if ([SELF, SHARE, ALL, PUBLIC].includes(cache)) {
            return cache;
        }
        return ALL;
    }
    get isMyWorkspace() {
        return this.spaceType === SELF;
    }
    get isShareWorkspace() {
        return this.spaceType === SHARE;
    }
    get isAllWorkspace() {
        return this.spaceType === ALL;
    }
    isSpaceTypeChange(val) {
        return this.spaceType !== val;
    }
    resetRouterQuery() {
        this.page = 1;
        this.searchName = '';
        this.labelName = '';
    }
    get isLabelOptionChanged() {
        return isEqual(this.originLabelOptions, this.labelOptions);
    }
    updateLabelOptions(options) {
        this.labelOptions = cloneDeep(options);
        this.originLabelOptions = cloneDeep(options);
    }
    editLabelOption({ label_id, label_name }) {
        const option = find(this.labelOptions, { label_id });
        if (option) {
            option.label_name = label_name;
        }
        else {
            this.labelOptions.push({ label_id, label_name });
        }
    }
    deleteLabelOption({ label_id }) {
        remove(this.labelOptions, { label_id: label_id });
        this.labelOptions = [...this.labelOptions];
    }
    addSelectedLabel(id) {
        this.selectedlabelIds.push(id);
    }
    removeSelectedLabel(id) {
        remove(this.selectedlabelIds, function (n) {
            return n === id;
        });
        this.selectedlabelIds = [...this.selectedlabelIds];
    }
    setSearchTypeInPane(searchType = WORKSPACE) {
        this.searchTypeInPane = searchType;
    }
    getDefaultWorkspaceSortKey() {
        const { cacheKey, sortKeyMap, defaultSortKey } = this;
        const sortKey = localStorage.getItem(cacheKey) || defaultSortKey;
        return sortKeyMap[sortKey] || defaultSortKey;
    }
    setWorkspaceSortKey(sortKey) {
        return localStorage.setItem(this.cacheKey, sortKey);
    }
    get isWorkspace() {
        return this.searchTypeInPane === WORKSPACE;
    }
    get isPatent() {
        return this.searchTypeInPane === PATENT;
    }
    get searchInWorkspace() {
        return this.isWorkspace;
    }
    get getSearchTypeList() {
        return [
            {
                key: WORKSPACE,
                value: this.i18n.t('workspace.taskCenter.workspace'),
            },
            {
                key: PATENT,
                value: this.i18n.t('workspace.recycleBin.type.SINGLEPATENT'),
            },
        ];
    }
    get searchTypeStr() {
        switch (this.searchTypeInPane) {
            case WORKSPACE: {
                return this.i18n.t('workspace.taskCenter.workspace');
            }
            case PATENT: {
                return this.i18n.t('workspace.recycleBin.type.SINGLEPATENT');
            }
            default: {
                return this.i18n.t('workspace.taskCenter.workspace');
            }
        }
    }
    get searchTypePlaceholder() {
        switch (this.searchTypeInPane) {
            case WORKSPACE: {
                return this.i18n.t('app.searchAcrossWorkspace.searchInputPlaceholderLongWs');
            }
            case PATENT: {
                return this.i18n.t('app.searchAcrossWorkspace.searchInputPlaceholderLongV2');
            }
            default: {
                return this.i18n.t('app.searchAcrossWorkspace.searchInputPlaceholderLongWs');
            }
        }
    }
    setRouter() {
        let query = {
            ...this.route.currentRoute.query,
            filterWords: this.searchName,
            searchType: this.isPatent ? this.searchTypeInPane : undefined,
            spaceType: this.spaceType,
        };
        localStorage.setItem(WORKSPACE_LIST_DEFAULT_TYPE_CACHE_KEY, this.spaceType);
        if (this.isWorkspace) {
            query.labelName = this.labelName;
            query.page = undefined;
            query.pageNum = `${this.pageNum}`;
        }
        if (this.isPatent) {
            query.pageNum = undefined;
            query.page = `${this.page}`;
        }
        query = pickBy(query, val => val);
        this.route.push({
            query,
        });
    }
};
WorkspaceLabelService = __decorate([
    provide(WorkspaceLabelServiceSymbol),
    __metadata("design:paramtypes", [])
], WorkspaceLabelService);
export { WorkspaceLabelService };
